export default __webpack_public_path__ + "static/section-5-img-1-acebb5539d480d7a99ea5109e3fbde9d.png";